import { useCallback, useState } from "react";

export default function useNotifications(maxItems = 20) {
  const [unreadCount, setUnreadCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const addNotification = useCallback(
    ({ message, type = "info" }) => {
      if (!message) return;
      setUnreadCount((prev) => prev + 1);
      setNotifications((prev) => {
        const next = [
          {
            id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
            message,
            type,
            timestamp: new Date().toISOString(),
          },
          ...(prev ?? []),
        ];
        return next.slice(0, maxItems);
      });
    },
    [maxItems],
  );

  const openMenu = useCallback((event) => {
    setAnchorEl(event.currentTarget);
    setUnreadCount(0);
  }, []);

  const closeMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return {
    unreadCount,
    notifications,
    anchorEl,
    addNotification,
    openMenu,
    closeMenu,
  };
}
